import { AbstractControl } from '@angular/forms';
import { distinctUntilChanged, skip, startWith } from 'rxjs/operators';
import { perListenerSession } from './listener-session';

/**
 * Non-debounced twin of `withChangeDebounced`: emits only on real changes of the control value,
 * synchronously. Use when a debounce would delay the reaction past the next user action.
 *
 * @param control Control used to seed distinctUntilChanged with its current value.
 * @param compare Custom equality for distinctUntilChanged (e.g. lodash `isEqual` for FormArray values).
 */
export function withChange<T>(control: AbstractControl, compare?: (previous: T, current: T) => boolean) {
    return perListenerSession<T, T>((s$) => s$.pipe(startWith(control.value), distinctUntilChanged(compare), skip(1)));
}
